import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Modal } from 'antd';
import { Player } from 'video-react';
import { useLocation } from 'react-router';
import { useBoolean, useUpdateEffect } from 'ahooks';
import { omit } from 'lodash-es';
import { Icon } from '@fuxi/eevee-icon';
import { Header, ScrollView, SlideSelect } from '@/components';
import noServiceBgImg from '@/assets/image/no-service-bg-gray.png';
import { useNav } from '@/hooks';
import { ALL_PAGES, COMMON_VIDEO_POSTER } from '@/constant';
import { ScrollViewRefAttrs } from '@/components/scroll-view';
import playIcon from '@/assets/image/play-icon.png';
import { useHelpFeedbackStore } from '../store/useHelpFeedbackStore';
import cx from './index.module.scss';

interface Props {}

const MODULE_2_TEXT: Record<HelpFeedback.CommonModule, string> = {
  robot: '认识机器人',
  manage: '品项视频',
  massageType: '末端功能',
  afterSale: '售后维护',
  version: '版本更新',
};

const UseSkills: React.FC<Props> = () => {
  const location = useLocation();
  const helpConfigList = useHelpFeedbackStore.use.helpConfigList();
  const scrollViewRef = useRef<ScrollViewRefAttrs>(null);
  const [isDrawerShow, { setTrue: setDrawerShow, setFalse: setDrawerHide }] = useBoolean(false);
  const [selectVideoItem, setSelectVideoItem] =
    useState<{
      videoUrl?: string;
      videoTitle?: string;
      videoCoverImageUrl?: string;
      types?: HelpFeedback.MassageType[];
      id: number;
      module: HelpFeedback.CommonModule;
    }>(null);

  const playerRef = useRef<any>(null);

  const nav = useNav();

  const isShowSkuSkills = useMemo(() => location?.state?.showSkuSkills, [location?.state?.showSkuSkills]);

  const [selectTab, setSelectTab] = useState<HelpFeedback.CommonModule>(isShowSkuSkills ? 'manage' : 'robot');

  const VIDEO_LIST = useMemo(
    () =>
      helpConfigList
        ?.filter(item => item?.module === selectTab)
        ?.map(item => ({
          ...omit(item, 'setting'),
          ...(item?.setting || {}),
        })),
    [helpConfigList, selectTab]
  );

  useUpdateEffect(() => {
    if (!isDrawerShow) {
      playerRef.current?.video?.pause?.();
    }
  }, [isDrawerShow]);

  useEffect(() => {
    scrollViewRef.current?.bsInstance?.scrollTo(0, 0);
    scrollViewRef.current?.handleRefresh();
  }, [selectTab]);

  return (
    <div className={cx('UseSkills')}>
      <Header backConfig={{ text: '返回', action: () => nav(ALL_PAGES.HELP_FEEDBACK) }} title="使用技巧" />
      <SlideSelect
        className={cx('slide-select')}
        value={selectTab}
        onChange={value => setSelectTab(value as any)}
        steps={
          isShowSkuSkills
            ? [
                {
                  value: 'manage',
                  label: '品项视频',
                },
              ]
            : [
                {
                  value: 'robot',
                  label: '认识机器人',
                },
                {
                  value: 'massageType',
                  label: '末端功能',
                },
                {
                  value: 'afterSale',
                  label: '售后维护',
                },
              ]
        }
      />
      <div className={cx('videos-container')}>
        <ScrollView className={cx('videos-wrapper')} ref={scrollViewRef}>
          {VIDEO_LIST?.length ? (
            <div className={cx('video-list')}>
              {VIDEO_LIST?.map(item => (
                <div
                  key={item.id}
                  className={cx('video-item')}
                  onClick={() => {
                    // item?.onClick?.();
                    setSelectVideoItem(item);
                    setDrawerShow();
                  }}
                >
                  <div className={cx('video-cover')}>
                    <img src={item?.videoCoverImageUrl} className={cx('cover-img')} alt="" />
                    <div className={cx('title')}>{item?.title}</div>
                    <img src={playIcon} className={cx('play-icon')} alt="" />
                  </div>
                  <div className={cx('sub-title')}>{item.title}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className={cx('empty')}>
              <img src={noServiceBgImg} alt="no-service" />
              <div>当前无内容</div>
            </div>
          )}
        </ScrollView>
      </div>
      <Modal
        getContainer={false}
        closeIcon={null}
        className={cx('modal-wrapper')}
        open={isDrawerShow}
        title={
          <div onClick={setDrawerHide}>
            <Icon className={cx('arrow')} name="arrow-back" />
            <span>{MODULE_2_TEXT[selectTab]}</span>
          </div>
        }
        onCancel={setDrawerHide}
        footer={null}
        maskClosable={false}
        width="100%"
        height="100%"
      >
        <Player ref={playerRef} poster={COMMON_VIDEO_POSTER} src={selectVideoItem?.videoUrl} aspectRatio="16:9" />
      </Modal>
    </div>
  );
};

export default UseSkills;
